"use client"

import type React from "react"
import { memo } from "react"
import type { NavItem } from "../../../types/header"
import NavLink from "./NavLink"

interface MobileNavigationProps {
  navItems: NavItem[]
  isAuthenticated: boolean
  isOpen: boolean
  onClose: () => void
}

const MobileNavigation: React.FC<MobileNavigationProps> = memo(({ navItems, isAuthenticated, isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <div className="mobile-nav">
      {navItems
        .filter((item) => {
          if (item.hideWhenAuth && isAuthenticated) return false
          if (item.requiresAuth && !isAuthenticated) return false
          return true
        })
        .map((item, index) => (
          <NavLink key={`mobile-${item.label}-${index}`} item={item} isMobile onMobileClose={onClose} />
        ))}
    </div>
  )
})

MobileNavigation.displayName = "MobileNavigation"

export default MobileNavigation
